// extracted by mini-css-extract-plugin
module.exports = {"box_list":"box_list-1N39Pu8d","box_list_pic":"box_list_pic-3IbGqbag","box_list_word":"box_list_word-TOGem4sM"};